export default "__VITE_ASSET__CHToHG3F__"